import React from "react"
import { LinkedinShareButton, TwitterShareButton } from "react-share"
import { FaXTwitter, FaLinkedin } from "react-icons/fa6"
import "./index.css"

const Card = ({ img, title, description, href }) => {
  const handleTweet = () => {
    const tweetUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      href
    )}&text=${title}`
    window.open(tweetUrl, "_blank")
  }
  return (
    <div className="blogCard">
      <div>
        <img src={img} alt={title} />
      </div>
      <div className="blog-des container">
        <h1>{title}</h1>
        <h4>{description}</h4>
        <div className="container row icons-share">
          <div>
            <h4>SHARE</h4>
          </div>
          <div>
            <button
              onClick={handleTweet}
              style={{ border: "none", background: "none", cursor: "pointer" }}
            >
              <FaXTwitter size={30} />
            </button>
          </div>
          <div>
            <LinkedinShareButton url={"https://www.workeye.ai/insights/"}>
              <FaLinkedin size={30} />
            </LinkedinShareButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card
